import { render } from "./NavComponent.vue?vue&type=template&id=4f63ef3b&scoped=true&ts=true"
import script from "./NavComponent.vue?vue&type=script&lang=ts"
export * from "./NavComponent.vue?vue&type=script&lang=ts"

import "./NavComponent.vue?vue&type=style&index=0&id=4f63ef3b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f63ef3b"]])

export default __exports__